import { render, staticRenderFns } from "./add-agency-auth.vue?vue&type=template&id=c22237c0&scoped=true"
import script from "./add-agency-auth.vue?vue&type=script&lang=js"
export * from "./add-agency-auth.vue?vue&type=script&lang=js"
import style0 from "./add-agency-auth.vue?vue&type=style&index=0&id=c22237c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22237c0",
  null
  
)

export default component.exports